<template>
    <div>

        <!-- AbdullahFixed added mt-5 here  -->
        <div class="row mt-5">
            <div class="col-sm-10">
                <b-button :href="$api_url+'/employee/template'" v-if="flag == 0" class="btn btn-primary rounded p-2 pr-4 pl-4 float-left"><b-icon icon="code-slash" ></b-icon> Download Template</b-button>

                <template v-if="flag == 1">
                    <!-- <b-button class="btn btn-primary rounded p-2 pr-4 pl-4 " @click="exportUpdate"><b-icon icon="code-slash" ></b-icon> Download Template</b-button> -->

                    <b-button class="btn btn-primary rounded p-2 pr-4 pl-4 ml-2" @click="exportUpdateWithStatus(1)"><b-icon icon="code-slash" ></b-icon> Template for Active Employees </b-button>

                    <b-button class="btn btn-primary rounded p-2 pr-4 pl-4 ml-2" @click="exportUpdateWithStatus(2)"><b-icon icon="code-slash" ></b-icon> Template for Inactive Employees </b-button>

                    <h5 class="mt-3">Upload the downloaded excel file after the modification.</h5>
                </template>
                <template v-if="flag == 2">
    <!-- Abdullah26 removed ml-2  -->
                    <b-button class="btn btn-primary rounded p-2 pr-4 pl-4  " @click="exportEmailPhone(1)"><b-icon icon="code-slash" ></b-icon> Template for Active Employees </b-button>

                    <b-button class="btn btn-primary rounded p-2 pr-4 pl-4 ml-2" @click="exportEmailPhone(2)"><b-icon icon="code-slash" ></b-icon> Template for Inactive Employees </b-button>

                    <h5 class="mt-3">Upload the downloaded excel file after the modification.</h5>
                </template>
            </div>
            <div class="col-sm-2">
                <a :href="$api_url+'/employee'" class="btn btn-primary rounded p-2 pr-4 pl-4 float-right"><span><b-icon icon="reply" rotate="0" flip-h="" class="mr-2" scale="2"></b-icon></span><span>Back to List</span></a>
            </div>
        </div>


        <b-overlay :show="showoverlay" rounded="sm" class="mt-4">
            <b-form-file id="datafile" name="datafile" @change="uploadFile"  accept=".xlsx,.xls"></b-form-file>
            <br />
            <!--<b-button type="button" v-if="has_file" @click="checkFileData" variant="primary" size="lg">Validate file data</b-button>
            <b-button type="button" v-if="has_file" @click="processFileData" variant="primary" size="lg">Process file data</b-button>-->


            <div v-if='errormsg'>
                <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                <ul class="list-group mt-4">
                    <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                </ul>
            </div>


            <div v-if="show_employee_list">
                <div class="mt-4 custom-search">
                    <h3>Imported employees ({{people}})</h3>

                    <b-input-group >
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search by Employee / Position / Branch / Email / Phone" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>


                <div class="card-body container">
                    <div class="row border-bottom  py-2">
                        <div class="col-sm-4 text-uppercase py-1 font-weight-bold row pl-4">
                            Organaizational Info
                        </div>
                        <div class="col-sm-3 text-uppercase py-1 font-weight-bold ">
                            Contact Info
                        </div>
                        <div class="col-sm-5 text-uppercase py-1 font-weight-bold pl-1">
                            Actions
                        </div>
                    </div>

                    <div class="row border-bottom py-2" v-for="employee in paginatedData" :key="employee.employee_id">
                        <div class="col-sm-4 justify-content-center row pl-4">
                            <div class="col-sm-4 px-0">
                                <img v-bind:src="$api_url+'/avatar/'+ employee.company_id + '/' + employee.pic" class="img-fluid img-thumbnail" />
                            </div>
                            <div class="col-sm-8">
                                <div class="text-uppercase py-1 font-weight-bold">{{employee.name}}</div>
                                <div>
                                    {{employee.jobposition}}<br />
                                    {{employee.department}}
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3 ">
                            {{employee.email}}<br />
                            {{employee.phone}}<br />
                            {{employee.employee_code}}
                        </div>

                        <div class="col-sm-5 px-0">
                            <b-button-group >
                                <b-button variant="outline-secondary" title="Edit" v-if="ce" @click="editEmployee(employee.employee_id , 0)">Info</b-button>
                                <b-button variant="outline-secondary" title="Contract" @click="editEmployee(employee.employee_id , 1)">Contract</b-button>
                                <b-button variant="outline-secondary" title="Investment" v-if="ce" @click="editEmployee(employee.employee_id , 2)">Investment</b-button>
                                <b-button variant="outline-secondary" title="Tax Card" v-if="ce" @click="editEmployee(employee.employee_id , 3)">Tax Card</b-button>
                                <b-button variant="outline-secondary" title="Pay Slip" v-if="ce" @click="editEmployee(employee.employee_id , 4)">Payslip</b-button>
                                <b-button variant="outline-secondary" title="Challan" v-if="ce" @click="editEmployee(employee.employee_id , 5)">Challan</b-button>
                            </b-button-group>
                        </div>
                    </div>
                    <div class="row p-2 float-right" v-if="paginatedData.length > 0">
                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>
                    <div class="row p-2" v-if="paginatedData.length == 0">
                        {{blankmsg}}
                    </div>
                </div>
            </div>



        </b-overlay>
  </div>
</template>
<script>

    export default{

        mounted() {
            //console.log('Bank info started..');
            //console.log(this.employee_id);
            //alert(this.cu);
        },
        props: ['flg'],
        data(){

            return {

                flag : this.flg,
                ce : true,
                empfile : null,
                has_file : false,
                errormsg : [],
                showoverlay : false,
                show_employee_list : false,
                people : 0,
                blankmsg : 'Fetching data..',

                upload_url : '',
                process_url : '',

                successmsg : false,
                warningmsg : false,
                dangermsg : false,

                employees : [],
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group : {name:'', email:'', phone:'' },
                search_by_id : {department_id:0, jobposition_id:0 , branch_id:0},

                depertments : [],
                jobtypes : [],
                branches : [],

                search:  '',
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

            }
        },
        methods:{

            setUrls:function()
            {
                this.flag = parseInt(this.flag);

                if(this.flag == 1)
                {

                    this.upload_url = this.$api_url+"/employee/import-for-update";
                    this.process_url = this.$api_url+'/employee/import-for-update/processdata';

                }
                else if(this.flag == 2)
                {

                    this.upload_url = this.$api_url+"/employee/import-employee-email-phone";
                    this.process_url = this.$api_url+'/employee/import-employee-email-phone/processdata';

                }
                else
                {

                    this.upload_url = this.$api_url+"/employee/import";
                    this.process_url = this.$api_url+'/employee/import/processdata';
                }

            },
            exportUpdate: function(flg = 0)
            {
                if(!this.checkNet()) return false;


                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_ids', 'all');
                formData.append('flg', flg);
                formData.append('forupdate', 1);

                axios.post(this.$api_url+'/employee/export-for-update', formData)
                    .then(function (response)
                    {
                        this.showoverlay = false;
                        //window.open(response.data);
                        var fileURL = response.data;

                        this.downloadFileContent(fileURL);

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },

            exportEmailPhone: function(flg = 0)
            {
                if(!this.checkNet()) return false;


                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_ids', 'all');
                formData.append('flg', 6);
                formData.append('forupdate', 1);

                if(flg==1)
                {
                    formData.append('template_filter', 'active');
                }
                else if(flg==2)
                {
                    formData.append('template_filter', 'inactive');
                }

                axios.post(this.$api_url+'/employee/export-for-update', formData)
                    .then(function (response)
                    {
                        this.showoverlay = false;
                        //window.open(response.data);
                        var fileURL = response.data;

                        this.downloadFileContent(fileURL);

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            exportUpdateWithStatus: function(flg = 0)
            {
                if(!this.checkNet()) return false;


                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_ids', 'all');

                if(flg==1)
                {
                    formData.append('template_filter', 'active');
                }
                else if(flg==2)
                {
                    formData.append('template_filter', 'inactive');
                }

                formData.append('forupdate', 1);

                axios.post(this.$api_url+'/employee/export-for-update', formData)
                    .then(function (response)
                    {
                        this.showoverlay = false;
                        //window.open(response.data);
                        var fileURL = response.data;

                        this.downloadFileContent(fileURL);

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            uploadFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.show_employee_list = false;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.upload_url, data , config).
                    then(function (response){

                        this.has_file = true;

                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.processFileData();

                    }.bind(this)).
                    catch(function (error)
                            {
                                //alert(error.response.data.errors);
                            });
            },
            processFileData:function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                this.errormsg = [];
                axios.get(this.process_url)
                .then(function (response) {

                        if(response.data.status)
                        {
                            this.$bvToast.toast('Data feed file successfully imported', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                            this.employees = response.data.employees;
                            if(this.employees.length == 0)
                                this.blankmsg = "Nothing found.";
                            else
                                this.people = this.employees.length;

                            this.show_employee_list = true;

                            setTimeout("location.href = '"+this.$api_url+"/employee';",1500);
                        }
                        else
                        {
                            this.errormsg = response.data.errors;
                        }

                    this.showoverlay = false;

                }.bind(this)).catch(function (error){


                    //currentObj.serverError(error);
                    currentObj.showoverlay = false;
                    currentObj.$bvToast.toast('Please correct the data and try again. There might be any non well formed numeric value encountered.' , {
                                            title: `Data Template Error`,
                                            variant: 'danger',
                                            solid: true
                                        });

                }); ;
            },



            resetPagination()
            {
                this.pagination.currentPage = 1;
                this.pagination.prevPage = '';
                this.pagination.nextPage = '';
            },
            paginate(array, length, pageNumber)
            {
                let l = parseInt(array.length);
                let m = parseInt(length);
                this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
                this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
                this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
                this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';

                if(l > 0)
                {
                    this.pagination.pages = Math.ceil(l / m);
                }
                this.people = l;
                return array.slice((pageNumber - 1) * length, pageNumber * length);
            },
            editEmployee:function(x , i)
            {
                if(!this.checkNet()) return false;

                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {
                        if(i > 0)
                            window.location.href = this.$api_url+'/employee/info?#=' + i;
                        else
                            window.location.href = this.$api_url+'/employee/info';

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.errormsg = error.response.data.errors;
                    });

            },


        },
        created: function(){
            this.setUrls();

            Fire.$on('reloadUsers', () => {this.processFileData()})
        },

        computed:
        {
            filteredData()
            {
                let filtered_list = this.employees;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                this.people = filtered_list.length;

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
